import { render, staticRenderFns } from "./EditarReparto.vue?vue&type=template&id=5848eb6c&scoped=true&"
import script from "./EditarReparto.vue?vue&type=script&lang=js&"
export * from "./EditarReparto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848eb6c",
  null
  
)

export default component.exports